import styled from 'styled-components';

export const Container = styled.div`
  min-width: 600px;
  p + p {
    margin-top: 10px;
  }

  p {
      font-family: 'Roboto';
      font-weight: 400;
      color: #333;
  }

  span {
    font-weight: 500;
  }
`;
